export type LocaleCode = "ja" | "en" | "id";

export type LocaleDef = {
  code: LocaleCode;
  label: string;
  shortLabel: string;
  flag: string;
};

export const LOCALES: LocaleDef[] = [
  { code: "ja", label: "日本語", shortLabel: "JP", flag: "🇯🇵" },
  { code: "en", label: "English", shortLabel: "EN", flag: "🇺🇸" },
  { code: "id", label: "Bahasa Indonesia", shortLabel: "ID", flag: "🇮🇩" },
];

export function findLocale(code: string): LocaleDef {
  return LOCALES.find((l) => l.code === code) ?? LOCALES[0];
}
